{
    "v": "5.12.1",
    "fr": 60,
    "ip": 0,
    "op": 3000,
    "w": 1080,
    "h": 1920,
    "nm": "2025-08-18_OXXO-SelfCheckout_All",
    "ddd": 0,
    "assets": [],
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 4,
            "nm": "Logo 2",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [540, 607.197, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [59, 59, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, 0],
                                                [36.465, -42.267],
                                                [0, 0],
                                                [0, 0],
                                                [15.367, 18.334],
                                                [0, 0],
                                                [0, 0],
                                                [-13.255, 19.849],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-19.844, 11.891],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-35.477, 43.094],
                                                [0, 0],
                                                [0, 0],
                                                [-15.788, -17.973],
                                                [0, 0],
                                                [0, 0],
                                                [12.791, -20.151],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [19.568, -12.346],
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [-53.442, -1.228],
                                                [0, 0],
                                                [0, 0],
                                                [12.977, 20.036],
                                                [0, 0],
                                                [0, 0],
                                                [-15.628, 18.109],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [15.014, -17.451],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [53.449, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-13.424, -19.734],
                                                [0, 0],
                                                [0, 0],
                                                [15.202, -18.473],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-14.609, 17.793],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [237.016, -112.663],
                                                [121.983, -37.355],
                                                [87.584, 2.51],
                                                [142.055, 67.721],
                                                [114.897, 89.308],
                                                [64.535, 29.232],
                                                [15.46, 86.122],
                                                [-11.4, 64.153],
                                                [41.875, 2.201],
                                                [6.972, -39.436],
                                                [29.424, -67.242],
                                                [64.92, -24.602],
                                                [95.518, -60.195],
                                                [145.687, -112.663],
                                                [-347.576, -112.663],
                                                [-347.576, 112.695],
                                                [-232.25, 112.695],
                                                [-119.06, 37.645],
                                                [-85.585, -3.015],
                                                [-141.556, -66.943],
                                                [-114.895, -89.15],
                                                [-63.167, -30.247],
                                                [-15.403, -88.258],
                                                [11.951, -66.91],
                                                [-39.884, -3.74],
                                                [-4.028, 37.082],
                                                [-26.62, 63.835],
                                                [-62.31, 23.582],
                                                [-92.075, 59.862],
                                                [-141.041, 112.695],
                                                [347.576, 112.695],
                                                [347.576, -112.663]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, -0.016], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Oxxo",
                            "np": 1,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "d": 3,
                                    "ty": "el",
                                    "s": {
                                        "a": 0,
                                        "k": [182.415, 182.421],
                                        "ix": 2
                                    },
                                    "p": { "a": 0, "k": [0, 0], "ix": 3 },
                                    "nm": "Ellipse Path 1",
                                    "mn": "ADBE Vector Shape - Ellipse",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [-234.3, -4.137],
                                        "ix": 2
                                    },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Oxxo",
                            "np": 1,
                            "cix": 2,
                            "bm": 0,
                            "ix": 2,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "d": 3,
                                    "ty": "el",
                                    "s": {
                                        "a": 0,
                                        "k": [182.421, 182.42],
                                        "ix": 2
                                    },
                                    "p": { "a": 0, "k": [0, 0], "ix": 3 },
                                    "nm": "Ellipse Path 1",
                                    "mn": "ADBE Vector Shape - Ellipse",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [241.544, -4.137],
                                        "ix": 2
                                    },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 90, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Oxxo",
                            "np": 1,
                            "cix": 2,
                            "bm": 0,
                            "ix": 3,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "mm",
                            "mm": 5,
                            "nm": "Merge Paths 1",
                            "mn": "ADBE Vector Filter - Merge",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.886274516582, 0.109803922474,
                                    0.164705887437, 1
                                ],
                                "ix": 4
                            },
                            "o": { "a": 0, "k": 100, "ix": 5 },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Oxxo",
                    "np": 5,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "d": 1,
                            "ty": "el",
                            "s": { "a": 0, "k": [115.462, 115.462], "ix": 2 },
                            "p": { "a": 0, "k": [0, 0], "ix": 3 },
                            "nm": "Ellipse Path 1",
                            "mn": "ADBE Vector Shape - Ellipse",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.886274516582, 0.109803922474,
                                    0.164705887437, 1
                                ],
                                "ix": 4
                            },
                            "o": { "a": 0, "k": 100, "ix": 5 },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [-234.3, -4.139], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 270, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Oxxo",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, -31.805],
                                        [-31.805, 0],
                                        [0, 31.793],
                                        [31.798, 0]
                                    ],
                                    "o": [
                                        [-31.805, 0],
                                        [0, 31.793],
                                        [31.798, 0],
                                        [0, -31.805],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0.003, -57.731],
                                        [-57.729, 0.004],
                                        [0.003, 57.731],
                                        [57.729, 0.004],
                                        [0.003, -57.731]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.886274516582, 0.109803922474,
                                    0.164705887437, 1
                                ],
                                "ix": 4
                            },
                            "o": { "a": 0, "k": 100, "ix": 5 },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [241.545, -4.139], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Oxxo",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 3,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [-347.576, -128.738],
                                        [347.576, -128.738],
                                        [347.576, 128.738],
                                        [-347.576, 128.738],
                                        [-347.576, -128.738]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                            "o": { "a": 0, "k": 100, "ix": 5 },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, -0.002], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Oxxo",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 4,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [-11.906, 0],
                                        [0, 0],
                                        [0, -11.906],
                                        [0, 0],
                                        [11.907, 0],
                                        [0, 0],
                                        [0, 11.908],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, -11.906],
                                        [0, 0],
                                        [11.907, 0],
                                        [0, 0],
                                        [0, 11.908],
                                        [0, 0],
                                        [-11.906, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [-347.576, -138.551],
                                        [-325.93, -160.197],
                                        [325.929, -160.197],
                                        [347.576, -138.551],
                                        [347.576, 138.55],
                                        [325.929, 160.197],
                                        [-325.93, 160.197],
                                        [-347.576, 138.55],
                                        [-347.576, -138.551]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.941176474094, 0.662745118141,
                                    0.160784319043, 1
                                ],
                                "ix": 4
                            },
                            "o": { "a": 0, "k": 100, "ix": 5 },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [-0.001, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Oxxo",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 5,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 4500,
            "st": 0,
            "ct": 1,
            "cp": true,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 2,
            "ty": 4,
            "nm": "Ellipse 1",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "t": 0,
                            "s": [169.776]
                        },
                        {
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "t": 394,
                            "s": [195.776]
                        },
                        {
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "t": 988,
                            "s": [222.776]
                        },
                        {
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "t": 1468,
                            "s": [172.776]
                        },
                        { "t": 3000, "s": [169.776] }
                    ],
                    "ix": 10
                },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 0,
                            "s": [841.037, 1770.936, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 315,
                            "s": [765.037, 1786.936, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 1622,
                            "s": [699.037, 2512.936, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        { "t": 3000, "s": [841.037, 1770.936, 0] }
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [55, 55, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "d": 1,
                            "ty": "el",
                            "s": { "a": 0, "k": [4505.021, 2954.223], "ix": 2 },
                            "p": { "a": 0, "k": [0, 0], "ix": 3 },
                            "nm": "Ellipse Path 1",
                            "mn": "ADBE Vector Shape - Ellipse",
                            "hd": false
                        },
                        {
                            "ty": "gs",
                            "o": { "a": 0, "k": 100, "ix": 9 },
                            "w": { "a": 0, "k": 5, "ix": 10 },
                            "g": {
                                "p": 3,
                                "k": {
                                    "a": 0,
                                    "k": [
                                        0, 1, 1, 1, 0.77, 1, 1, 1, 1, 1, 1, 1,
                                        0, 0.15, 0.77, 0.075, 1, 0
                                    ],
                                    "ix": 8
                                }
                            },
                            "s": {
                                "a": 0,
                                "k": [1518.338, -1263.075],
                                "ix": 4
                            },
                            "e": {
                                "a": 0,
                                "k": [-1517.716, 1264.347],
                                "ix": 5
                            },
                            "t": 1,
                            "lc": 1,
                            "lj": 1,
                            "ml": 10,
                            "ml2": { "a": 0, "k": 10, "ix": 13 },
                            "bm": 0,
                            "nm": "Gradient Stroke 1",
                            "mn": "ADBE Vector Graphic - G-Stroke",
                            "hd": false
                        },
                        {
                            "ty": "gf",
                            "o": { "a": 0, "k": 100, "ix": 10 },
                            "r": 1,
                            "bm": 0,
                            "g": {
                                "p": 3,
                                "k": {
                                    "a": 0,
                                    "k": [
                                        0, 1, 1, 1, 0.77, 1, 1, 1, 1, 1, 1, 1,
                                        0, 0.15, 0.77, 0.075, 1, 0
                                    ],
                                    "ix": 9
                                }
                            },
                            "s": { "a": 0, "k": [-579.151, 1491.402], "ix": 5 },
                            "e": { "a": 0, "k": [579.653, -1492.519], "ix": 6 },
                            "t": 1,
                            "nm": "Gradient Fill 1",
                            "mn": "ADBE Vector Graphic - G-Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 4500,
            "st": 0,
            "ct": 1,
            "cp": true,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 3,
            "ty": 4,
            "nm": "Ellipse",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "t": 0,
                            "s": [258.498]
                        },
                        {
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "t": 339,
                            "s": [282.498]
                        },
                        {
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "t": 1852,
                            "s": [265.498]
                        },
                        {
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "t": 2469,
                            "s": [312.498]
                        },
                        { "t": 2990, "s": [258.498] }
                    ],
                    "ix": 10
                },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 0,
                            "s": [611.253, 1771.165, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 240,
                            "s": [557.253, 1755.165, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 1156,
                            "s": [477.253, 2847.165, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 1917,
                            "s": [709.253, 1779.165, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 2414,
                            "s": [637.253, 2527.165, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        { "t": 2990, "s": [611.253, 1771.165, 0] }
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [70, 70, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "d": 1,
                            "ty": "el",
                            "s": { "a": 0, "k": [2666.901, 4967.943], "ix": 2 },
                            "p": { "a": 0, "k": [0, 0], "ix": 3 },
                            "nm": "Ellipse Path 1",
                            "mn": "ADBE Vector Shape - Ellipse",
                            "hd": false
                        },
                        {
                            "ty": "gs",
                            "o": { "a": 0, "k": 100, "ix": 9 },
                            "w": { "a": 0, "k": 5, "ix": 10 },
                            "g": {
                                "p": 3,
                                "k": {
                                    "a": 0,
                                    "k": [
                                        0, 1, 1, 1, 0.77, 1, 1, 1, 1, 1, 1, 1,
                                        0, 0.15, 0.77, 0.075, 1, 0
                                    ],
                                    "ix": 8
                                }
                            },
                            "s": { "a": 0, "k": [1355.881, 202.972], "ix": 4 },
                            "e": { "a": 0, "k": [-1357.609, -202.64], "ix": 5 },
                            "t": 1,
                            "lc": 1,
                            "lj": 1,
                            "ml": 10,
                            "ml2": { "a": 0, "k": 10, "ix": 13 },
                            "bm": 0,
                            "nm": "Gradient Stroke 1",
                            "mn": "ADBE Vector Graphic - G-Stroke",
                            "hd": false
                        },
                        {
                            "ty": "gf",
                            "o": { "a": 0, "k": 100, "ix": 10 },
                            "r": 1,
                            "bm": 0,
                            "g": {
                                "p": 3,
                                "k": {
                                    "a": 0,
                                    "k": [
                                        0, 1, 1, 1, 0.77, 1, 1, 1, 1, 1, 1, 1,
                                        0, 0.15, 0.77, 0.075, 1, 0
                                    ],
                                    "ix": 9
                                }
                            },
                            "s": { "a": 0, "k": [865.675, 2197.375], "ix": 5 },
                            "e": {
                                "a": 0,
                                "k": [-866.094, -2199.339],
                                "ix": 6
                            },
                            "t": 1,
                            "nm": "Gradient Fill 1",
                            "mn": "ADBE Vector Graphic - G-Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 4500,
            "st": 0,
            "ct": 1,
            "cp": true,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 4,
            "ty": 4,
            "nm": "Dark BG",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [540, 960, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [559.75, 1218.25, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [-559.5, 1218],
                                        [559.5, 1218],
                                        [559.5, -1218],
                                        [-559.5, -1218]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.537254901961, 0.090196078431,
                                    0.086274509804, 1
                                ],
                                "ix": 4
                            },
                            "o": { "a": 0, "k": 100, "ix": 5 },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [559.75, 1218.25], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 3088,
            "st": 0,
            "ct": 1,
            "cp": true,
            "bm": 0
        }
    ],
    "markers": [],
    "props": {}
}
